export default "__VITE_ASSET__7c82a49f__"